import {
  CHANGE_SIM_TO_ESIM,
  CHANGE_SIM_TO_ESIM_ERROR,
  CLEAN_CHANGE_SIM_TO_ESIM,
  CLEAN_CHANGE_SIM_TO_ESIM_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function changeSimToEsimReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SIM_TO_ESIM:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case CHANGE_SIM_TO_ESIM_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_CHANGE_SIM_TO_ESIM:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success-clean',
      };

    case CLEAN_CHANGE_SIM_TO_ESIM_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error-clean',
      };
    default:
      return state;
  }
}
